import { makeStyles } from '@material-ui/core';

const useCommonStyles = () => {
  const useStyles = makeStyles({
    overlayComponentParentBox: {
      display: 'flex',
      color: 'black'
    },
    overlayHeaderParentBox: {
      display: 'flex',
      paddingBottom: '10px',
      borderBottom: '2px solid black'
    },
    overlayButtonBox: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    buttonStyle: {
      borderRadius: '25px',
      marginRight: '5px'
    },
    closeIconStyle: {
      color: 'white',
      marginTop: '10px',
      fontSize: '20px'
    },
    pageInfoStyle: {
      display: 'inline',
      color: 'black',
      marginRight: '5px'
    },
    arrowStyle: {
      color: 'white',
      marginLeft: '2px'
    },
    iconBox: {
      backgroundColor: 'black',
      borderRadius: '50px',
      height: '40px',
      width: '40px'
    },
    styledCard: {
      width: '100%',
      borderRadius: 8,
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      position: 'relative',
      backgroundColor: '#e8f5e9',
      border: '1px solid #333',
      margin: '8px 0',
      transition: 'all 0.3s ease'
    },
    styledCardFullscreen: {
      width: '80vw',
      minHeight: '50vh',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 1000,
      boxShadow: 'none'
    },
    backgroundOverlay: {
      display: 'none',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 999
    },
    backgroundOverlayVisible: {
      display: 'block'
    },
    cardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid #333',
      marginBottom: '8px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '0 8px'
    },
    cardHeaderTitle: {
      paddingRight: '10px'
    },
    expandableCardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%'
    },
    expandableCardAction: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    cardBody: {
      fontSize: '12px',
      maxHeight: '50vh',
      overflowY: 'auto',
      padding: '8px 16px',
      scrollbarWidth: 'thin',
      scrollbarColor: 'gray white'
    },
    chatFeedbackContainer: {
      width: '25%'
    },
    dialogModalContainer: {
      minWidth: '75%',
      flex: '0 0 75%',
      marginLeft: '10px',
      borderRight: '2px solid black',
      paddingRight: '10px'
    },
    dialogFullWidthContainer: {
      minWidth: '100%',
      marginLeft: '10px',
      borderRight: '2px solid black',
      paddingRight: '10px'
    },
    textContent: { textAlign: 'left' },
    chatTab: {
      fontSize: '12px !important',
      fontWeight: 'bold !important'
    },
    tabContent: {
      padding: '16px'
    },
    feedbackCard: {
      overflowY: 'auto',
      minHeight: '225px'
    },
    cardHeaderCustom: {
      background: '#34282808 !important'
    },
    feedbackActions: {
      display: 'flex',
      gap: '16px',
      marginTop: '16px'
    },
    likeButton: {
      '&:hover': {
        backgroundColor: 'transparent !important',
        borderColor: '#1A202C',
        color: '#1A202C'
      }
    },
    dislikeButton: {
      color: '#f44336 !important',
      backgroundColor: 'transparent !important',
      borderColor: '#f44336 !important',
      '&:hover': {
        backgroundColor: 'transparent !important',
        borderColor: '#f44336 !important',
        color: '#f44336 !important'
      }
    },
    divider: {
      margin: '16px 0 !important'
    },
    commentChipBox: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
      marginTop: '8px',
      width: '100%',
      minWidth: 0
    },
    feedbackCommentText: {
      padding: '8px 12px',
      borderRadius: '16px',
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      color: '#1A202C',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      width: '100%',
      boxSizing: 'border-box'
    },
    dividerColor: {
      color: '#1A202C'
    },
    progressBarBlur: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%) !important'
    },
    message: {
      top: '50%',
      left: '0%',
      bottom: '0%',
      right: '0%',
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    positionChatgpt: {
      position: 'fixed',
      top: '50%',
      left: '50%'
    },
    positionAiAdmin: {
      position: 'relative',
      paddingTop: '100px'
    },
    graphDetails: {
      paddingLeft: '16px',
      margin: 0
    },
    fullWidth: {
      width: '100%'
    },
    cardMargin: {
      margin: '0 8px'
    },
    noDataPadding: {
      padding: '16px'
    },
    expandableCard: {
      maxHeight: '50vh'
    }
  });
  return useStyles();
};

export default useCommonStyles;
